import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@engyalo/design-system';
import { MessageType } from 'components/Messages';
import { getMessagePreviewText } from 'helpers/messagePreview';
import { ReplyPreviewContainer, AccentBar, PreviewContent, SenderName, PreviewText } from './style';

interface ReplyPreviewProps {
  message: MessageType;
  onDismiss: () => void;
}

const ReplyPreview: React.FC<ReplyPreviewProps> = ({ message, onDismiss }) => {
  const { t } = useTranslation();
  const senderName = message.chat?.name || message.chat?.username || '';

  return (
    <ReplyPreviewContainer data-testid="replyPreview">
      <AccentBar />
      <PreviewContent>
        <SenderName data-testid="replyPreviewSender" noWrap>
          {senderName}
        </SenderName>
        <PreviewText data-testid="replyPreviewText" noWrap>
          {getMessagePreviewText(message.chat, t)}
        </PreviewText>
      </PreviewContent>
      <IconButton
        data-testid="replyPreviewDismiss"
        onClick={onDismiss}
        variant="text"
        color="neutral2"
        size="small"
        aria-label={t('cancel')}
      >
        <i className="fa-regular fa-xmark" />
      </IconButton>
    </ReplyPreviewContainer>
  );
};

export default ReplyPreview;
